import api from '@/services/api';

export default {
  async getDropdown() {
    try {
      let response = await api.get('Workflows/Dropdown');
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return [];
    } catch (ex) {
      console.error(ex);
      return [];
    }
  },
  async submitBudgetForApproval(budgetIterationId/*, note*/, lastModifiedTimestamp) {
    try {
      let requestBody = {
        note: '',
        lastModifiedTimestamp: lastModifiedTimestamp
      };
      let response = await api.post(`Workflows/${budgetIterationId}/SubmitForApproval`, requestBody);
      if (response && response.status == 200) {
        return true;
      }
      return false;
    } catch (ex) {
      console.error(ex);
      return false;
    }
  },
  async approveBudget(budgetIterationId/*, note*/, lastModifiedTimestamp) {
    try {
      let requestBody = {
        note: '',
        lastModifiedTimestamp: lastModifiedTimestamp
      };

      let response = await api.post(`Workflows/${budgetIterationId}/Approve`, requestBody);
      if (response && response.status == 200) {
        return true;
      }
      return false;
    } catch (ex) {
      console.error(ex);
      return false;
    }
  },
  async disputeBudget(budgetIterationId, note, lastModifiedTimestamp) {
    try {
      let requestBody = {
        note: note,
        lastModifiedTimestamp: lastModifiedTimestamp
      };
      let response = await api.post(`Workflows/${budgetIterationId}/Dispute`, requestBody);
      if (response && response.status == 200) {
        return true;
      }
      return false;
    } catch (ex) {
      console.error(ex);
      return false;
    }
  },
}
